export const pagingForUnitsCount = 15;
